import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Input from '../../../components/bootstrap/forms/Input';
import Button from '../../../components/bootstrap/Button';
import Select from '../../../components/bootstrap/forms/Select';
import Card, { CardBody, CardTitle } from '../../../components/bootstrap/Card';
import Badge from '../../../components/bootstrap/Badge';

import data, { CATEGORIES } from './helper/dummyKnowledgeData';
import { demoPages } from '../../../menu';
import useDarkMode from '../../../hooks/useDarkMode';
import useTourStep from '../../../hooks/useTourStep';
import logolong from '../../../assets/logos/logolongblue.png';
import Icon from '../../../components/icon/Icon';

// eslint-disable-next-line react/prop-types
const Item = ({ id, image, title, description, tags, color, icon }) => {

	useTourStep(15);
	const { darkModeStatus } = useDarkMode();

	const navigate = useNavigate();
	const handleOnClick = useCallback(
		() => navigate(`../${demoPages.knowledge.subMenu.itemID.path}/${id}`),
		[navigate, id],
	);
	return (
		<Card
			className='cursor-pointer shadow-3d-primary shadow-3d-hover'
			onClick={handleOnClick}
			data-tour={title}>
			<CardBody>
				<div
					style={{ maxHeight: "20vh" }}
					className={classNames(
						'ratio ratio-1x1',
						'rounded-2',
						`bg-l${darkModeStatus ? 'o25' : '10'}-${color}`,
						'mb-3',
					)}>
					<div className='p-4'>
						<Icon style={{ width: "100%", height: "100%", }}
							icon={icon}
						/>
					</div>
				</div>
				<p className='h3'>{title}</p>
				<p className='text-muted truncate-line-4 h5'>{description}</p>
				<div className='row g-2'>
					{!!tags &&
						// eslint-disable-next-line react/prop-types
						tags.map((tag) => (
							<div key={tag.text} className='col-auto'>
								<Badge isLight color={tag.color} className='px-3 py-2'>
									{tag.text}
								</Badge>
							</div>
						))}
				</div>
			</CardBody>
		</Card>
	);
};

const KnowledgeGridPage = () => {
	const { darkModeStatus } = useDarkMode();

	const [filterableData, setFilterableData] = useState(data);

	const searchAndFilterData = (searchValue, category) => {
		let tempData = data;

		if (category)
			tempData = data.filter((item) =>
				item.categories.find((categ) => categ.value === category),
			);

		return tempData.filter((item) => {
			return (
				item.title.toLowerCase().includes(searchValue) ||
				item.description.toLowerCase().includes(searchValue) ||
				item.content.toLowerCase().includes(searchValue) ||
				item.categories.find((categ) => categ.text.toLowerCase().includes(searchValue)) ||
				item.tags.find((tag) => tag.text.toLowerCase().includes(searchValue))
			);
		});
	};

	const debounce = (func, wait) => {
		let timeout;

		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};

			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	};

	const onFormSubmit = (values) => {
		const searchValue = values.search.toString().toLowerCase();
		const newData = searchAndFilterData(searchValue, values.category);

		if (!values.search && !values.category) {
			setFilterableData(data);
		} else {
			setFilterableData(newData);
		}
	};

	const formik = useFormik({
		initialValues: {
			search: '',
			category: '',
		},
		onSubmit: onFormSubmit,
		onReset: () => setFilterableData(data),
	});

	return (
		<PageWrapper title={demoPages.knowledge.subMenu.grid.text}>
			<Page>
				{/* <div className='row'>
					<div className='col-12 text-center my-5'>
						<div className='row'>
							<div className='col'>
								<div>
									<img style={{ maxWidth: "80%" }} src={logolong}></img>
								</div>
							</div>
						</div>
						<br />
						<div className='row'>
							<div className='col'>
								<span className='display-5 fw-bold'>Welcome To FinSpace</span>
							</div>
						</div>
						<div className='row justify-content-md-center'>
							<div className='col-8 center-text'>
								<span className='display-6'>FinSpace is your all-in-one Financial Project Management Platform.</span>
							</div>
						</div>
					</div>
				</div> */}
				<div className='row mb-5'>
					{filterableData.map((item) => (
						<div key={item.id} className='col-xl-6 col-lg-6 col-md-6'>
							{/* eslint-disable-next-line react/jsx-props-no-spreading */}
							<Item {...item} />
						</div>
					))}
				</div>
			</Page>
		</PageWrapper>
	);
};

export default KnowledgeGridPage;
